/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
const ImageBox = ({ image, className }) => {
    return (

        <div className="box-12 box-md-6 img-box">
            <div className={ `inner-box customAnim ${className}` }>
                <figure style={ { backgroundImage: image } }></figure>
            </div>
        </div>

    );
};

export default ImageBox;